import { FC } from 'react';

import KebabOptions from 'common/components/custom/kebab-options/KebabOptions';
import HighlightedText from 'common/components/custom/highlighted-text/HighlightedText';
import { Icon } from 'common/components';
import { SearchVM } from 'common/models';
import { EntityActions } from 'common/enums';
import { ICON_COLLECTION } from 'assets/media/icons';

import './FilterList.scss';
import { UseMasterDataAccess } from 'modules/master-data/role-access-hooks/useMasterDataAccess';

type FilterListProps = {
    searchVal: string;
    data: SearchVM;
    isUploadDisabled: boolean;
    uploadedUser: string;
    isSyncInProgress: boolean;
    masterDataFeatureActionList: UseMasterDataAccess;
    onAction: (action: any, data: any) => void;
    handleDetailsClick: (data: any) => void;
};

const FilterList: FC<FilterListProps> = ({
    searchVal,
    data,
    isUploadDisabled,
    uploadedUser,
    isSyncInProgress,
    masterDataFeatureActionList,
    onAction,
    handleDetailsClick
}: FilterListProps) => {
    return (
        <>
            <div className="filter-container">
                <div className="filter-content">
                    <div className="filter-text">
                        <HighlightedText text={data.name} highlight={searchVal} />
                    </div>
                    <div className="filter-breadcrumb">{data.path}</div>
                </div>
                <div className="details-icon-wrapper">
                    <Icon
                        className="details-icon"
                        src={ICON_COLLECTION.IC_Info}
                        onClick={() => handleDetailsClick(data)}
                        title={EntityActions.Details}
                    />
                </div>
                <div className="entity-actions">
                    <KebabOptions
                        data={data}
                        isUploadDisabled={isUploadDisabled}
                        uploadedUser={uploadedUser}
                        isSyncInProgress={isSyncInProgress}
                        masterDataFeatureActionList={masterDataFeatureActionList}
                        onAction={onAction}
                    />
                </div>
            </div>
        </>
    );
};

export default FilterList;
